import { utils } from "react-grid-layout";
import omitBy from "lodash/omitBy";
import keyBy from "lodash/keyBy";
import mapValues from "lodash/mapValues";
import WidgetPosition from "views/logic/widgets/WidgetPosition";
const layoutItemToPosition = ({ i, x, y, w, h }) => ({
  id: i,
  col: x + 1,
  row: y + 1,
  height: h,
  width: w
});
export const layoutToPositions = (layout) => layout.map(layoutItemToPosition);
const positionItemToLayout = ([id, position]) => {
  const { col, row, height, width } = position;
  return {
    i: id,
    x: col ? Math.max(col - 1, 0) : 0,
    y: row === void 0 || row <= 0 ? Infinity : row - 1,
    h: height || 1,
    w: width || 1
  };
};
export const positionsToLayout = (widgetPositions) => Object.entries(widgetPositions).map(positionItemToLayout);
export const normalizeWidgetPositions = (widgetPositions, widgetById) => {
  const filtratedWidgetPositions = omitBy(widgetPositions, (_, id) => !widgetById[id]);
  const layout = positionsToLayout(filtratedWidgetPositions);
  const compactedLayout = utils.compact(layout, "vertical", 12);
  const positions = keyBy(layoutToPositions(compactedLayout), "id");
  return mapValues(
    positions,
    ({ col, row, width, height }) => WidgetPosition.builder().row(row).col(col).width(width).height(height).build()
  );
};
